 const timelineEvents = [
  {
    year: 2024,
    title: "Launched AI Product Suite",
    description:
      "Introduced a new generation of AI-powered tools for operational intelligence, customer sentiment analysis, and autonomous decision-making. The suite became a game-changer in digital transformation journeys across industries.",
    source: "PRNews",
  },
  {
    year: 2023,
    title: "Acquired Competitor",
    description:
      "Acquired a smaller but innovative AI-driven analytics firm to enhance in-house capabilities in predictive modeling and business insights. The acquisition led to the integration of real-time data forecasting into the core product suite.",
    source: "Reuters",
  },
  {
    year: 2021,
    title: "Recognized as Industry Leader",
    description:
      "Named a leader in Gartner's Magic Quadrant for Intelligent Business Platforms. Praised for customer support, innovation, and modularity of its enterprise solutions.",
    source: "Gartner Report",
  },
  {
    year: 2020,
    title: "Series B Funding",
    description:
      "Raised $25M in Series B to scale globally, invest in R&D, and enhance cybersecurity measures. Funding round led by Sequoia Capital with participation from Insight Partners.",
    source: "Crunchbase",
  },
  {
    year: 2019,
    title: "Global Expansion Begins",
    description:
      "Opened offices in Singapore, London, and Toronto to support growing international demand. Established dedicated support teams and localized features for Asia-Pacific and EMEA regions.",
    source: "Business Insider",
  },
  {
    year: 2018,
    title: "Reached 1M Users",
    description:
      "Surpassed 1 million active users across multiple regions. This growth was fueled by strategic partnerships and an expanding suite of enterprise integrations.",
    source: "TechCrunch",
  },
];


const LinkedinTimeline = () => {
  return (
    <div className="bg-white py-6 rounded-2xl shadow-md border border-gray-300 mt-0 2xl:mt-20 max-h-[65vh]  mx-auto  px-6">
      <div className="relative ml-40 before:absolute before:top-0 before:bottom-0 before:left-1 before:w-0.5 before:border-l before:border-dashed before:border-gray-300">
        {timelineEvents.map((data, index) => (
          <div key={index} className="relative flex items-start mb-12">
            {/* Left Column: Year & Title */}
            <div className="absolute -left-40 w-36 text-right pr-4">
              <p className="text-sm text-gray-500">{data.year}</p>
              <p className="text-gray-700 font-medium">{data.title}</p>
            </div>

            {/* Dot: perfectly over the dashed line */}
            <div className="absolute left-0 top-1.5 -ml-[3px] w-4 h-4 rounded-full bg-gray-200   shadow" />

            {/* Right Column: Description */}
            <div className="ml-6 text-gray-700 max-w-4xl text-sm">
              <p>
                {data.description}
                <span className="ml-2 inline-block  text-xs text-gray-800 border border-gray-300 font-medium px-2 py-1 rounded-full ">
                  {data.source}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
 export default LinkedinTimeline;